import dayjs from "dayjs";

const weekDays = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];

function formatDate(data) {
	if (dayjs(data).format("DD/MM/YYYY") === dayjs().format("DD/MM/YYYY")) {
		return dayjs(data).format("HH:mm");
	} else if (dayjs().subtract(1, "day").format("DD/MM/YYYY") === dayjs(data).format("DD/MM/YYYY")) {
		return "Ontem";
	} else if (dayjs().subtract(7, "day") <= dayjs(data)) {
		return weekDays[new Date(dayjs(data)).getDay()];
	}
	return dayjs(data).format("DD/MM/YYYY");
}

function converterDecimalParaHorasMinutos(valorDecimal) {
	const horas = Math.floor(valorDecimal / 60);
	const minutos = valorDecimal % 60;

	if (horas > 0) {
		if (minutos > 0) {
			return horas + " hora(s) e " + minutos + " minuto(s)";
		} else {
			return horas + " hora(s)";
		}
	} else {
		return minutos + " minuto(s)";
	}
}

export { formatDate, converterDecimalParaHorasMinutos };
